import { useCustomSelector } from '@/core/redux/hooks';
import { formatNumber } from '@/app/shared/utils';

interface CoinsProps {
	isAnimated: boolean;
	counter?: number;
}

export const Coins: React.FC<CoinsProps> = ({
	isAnimated,
	counter: count,
}: CoinsProps) => {
	/*********************
	// #region Redux
	**********************/
	const { counter } = useCustomSelector((state) => state.counter);

	/*********************
	// #region Template
	**********************/
	return (
		<div
			className={`flex flex-col w-full items-center z-10 ${
				isAnimated ? 'animate-coins-block' : ''
			}`}
		>
			<div className="flex items-center gap-2">
				<img
					src={process.env.VITE_COIN_IMAGE}
					className={`w-[50px] ${
						isAnimated ? 'animate-coin' : ''
					} drop-shadow-lg counter-shuriken`}
				/>
				<p className="text-3xl leading-none font-bold text-shadow counter-numbers">
					{formatNumber(Math.trunc(count ? count : counter))}
				</p>
			</div>

			{/* <>
				

				<div className="flex items-center leading-none text-sm text-yellow-400 text-shadow-sm font-semibold counter-increment">
					{process.env.VITE_ENABLE_TOTAL_COINS ? (
						<>
							
							{t('coins.counterPerHour')}
							<TooltipProvider>
								<Tooltip open={isOpen}>
									<TooltipTrigger>
										<div
											className="rounded-lg p-1"
											onClick={() => setIsOpen(!isOpen)}
										>
											<MdInfoOutline />
										</div>
									</TooltipTrigger>

									<TooltipContent>
										<p className="text-xs pb-0">
											{t('coins.tooltipTapInfo')}
										</p>
									</TooltipContent>
								</Tooltip>
							</TooltipProvider>
						</>
					) : (
						
					)}
				</div>
			</> */}
			{/* )} */}
		</div>
	);
};
